import toString from './to-string';
var lowerCase = function (str) {
    return toString(str).toLowerCase();
};
export default lowerCase;
//# sourceMappingURL=lower-case.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/layout/node_modules/@antv/util/esm/lodash/lower-case.js
// module id = null
// module chunks = 